import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { getTextColorVariable } from "../../utils/text";
var convertVariable = function convertVariable(value) {
  if (!value) {
    return undefined;
  }
  return typeof value === 'string' ? value : "".concat(value, "px");
};
export var composeCSSVariables = function composeCSSVariables(_ref) {
  var lineHeight = _ref.lineHeight,
    size = _ref.size,
    variant = _ref.variant,
    _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? 'regular' : _ref$weight,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary' : _ref$color,
    align = _ref.align,
    transform = _ref.transform;
  var generateStylesObject = function generateStylesObject() {
    return _objectSpread(_objectSpread(_objectSpread(_defineProperty({}, '--text-color', getTextColorVariable(color)), align ? _defineProperty({}, '--text-align', align) : {}), transform ? _defineProperty({}, '--text-transform', transform) : {}), !variant ? _objectSpread(_objectSpread(_defineProperty({}, '--text-size', typeof size === 'string' ? "var(--font-size-".concat(size, ")") : convertVariable(size)), weight ? _defineProperty({}, '--text-weight', "var(--font-weight-".concat(weight, ")")) : {}), lineHeight ? _defineProperty({}, '--text-line-height', convertVariable(lineHeight)) : {}) : {});
  };
  return {
    variant: variant,
    generatedStyles: generateStylesObject()
  };
};